import { atom } from "jotai";

// Shared atoms to control modal visibility across components
export const uploadModalOpenAtom = atom(false);
export const libraryModalOpenAtom = atom(false);
